import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { LanguageProvider } from './context/LanguageProvider';
import { Provider } from 'react-redux';
import store from '../src/redux/store';
import Cookies from 'js-cookie';

const aaa = Cookies.get('organizationCountry');

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
 // <React.StrictMode>
    <Provider store={store}>
      <LanguageProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
      </LanguageProvider>
    </Provider>
 // </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
